import moment from "moment";

import {
  initLoading,
  endLoading,
  setError,
  setAllClasses,
  setRatingCriterias,
  setClassesForRating,
  setAllLingos,
  setLevels,
  setNotif,
  setLengthNotif,
  setPaginationNotif,
  setLingoPlans,
  setLingoTools,
  setAllPlans,
  setDemoClasses,
  setDemoClassMessages,
  setDemoClass,
  setAllTeachers,
  setNextClassesWA,
  setNextClasses,
  setAllPreviousClasses,
  setAllNextClasses,
  setAllLastSchedules,
} from "../slices/generics.slice";
import api from "../../services/api";
import { cap } from "../../utils/utils";
import { logout } from "./user.middleware";
import { decryptIfEncrypted } from "../../utils/fieldDecryptor";
import axios from "axios";

export const getClassesCalendar = (params) => {
  return async (dispatch) => {
    dispatch(initLoading());
    const lang = localStorage.getItem("i18nextLng");

    const { startAt, endAt, lingoLanguageId, type, planId, status, teacher, student, orderByAsc, activeScreen } =
      params;

    let newFormatStart = moment(startAt).format("YYYY-MM-DD");
    let newFormatEnd = moment(endAt).format("YYYY-MM-DD");
    let newFormatLingoLanguage = lingoLanguageId === "" ? "" : `&lingoLanguageId=${lingoLanguageId}`;
    let newFormatType = type === "" ? "" : `&type=${type}`;
    let newFormatPlanId = planId === "" ? "" : `&planId=${planId}`;
    let newFormatStatus = status === "" ? "" : `&status=${status}`;
    let newFormatTeacher = teacher === "" ? "" : `&teacher=${teacher}`;
    let newFormatStudent = student === "" ? "" : `&student=${student}`;

    try {
      const response = await api.get(
        `/classSchedules${
          activeScreen === "list" ? "Agrouped" : ""
        }?startAt=${newFormatStart}&endAt=${newFormatEnd}${newFormatLingoLanguage}${newFormatType}${newFormatPlanId}${newFormatStatus}${newFormatTeacher}${newFormatStudent}&orderByAsc=${orderByAsc}&lang=${lang}`,
      );
      const resp = response?.data?.result?.items;
      if (activeScreen === "list") {
        await dispatch(setNextClasses(resp));
      }
      await dispatch(setNextClassesWA(resp));
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getNextClass", error);
      dispatch(setError(error.message));
    }
    dispatch(endLoading());
  };
};

export const getNextClass = (loading = false) => {
  return async (dispatch) => {
    loading && dispatch(initLoading());

    const lang = localStorage.getItem("i18nextLng");
    const atualDate = moment(new Date()).subtract(30, "minutes").utc().format("YYYY-MM-DDTHH:mm:ss.sss");

    const filterStartDate = "&startAt=" + atualDate;

    try {
      const response = await api.get(
        `/classSchedulesAgrouped?type=hometop5upcoming&pageNumber=1&pageSize=20${filterStartDate}&orderByAsc=originalScheduledDateTimeUTC&lang=${lang}`,
      );
      const resp = response?.data?.result?.items;

      await dispatch(setAllClasses(resp));
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getNextClass", error);
      dispatch(setError(error.message));
      loading && dispatch(endLoading());
    } finally {
      loading && dispatch(endLoading());
    }
  };
};

export const postCancelClass = (data) => {
  return async (dispatch) => {
    try {
      const response = await api.post(`/classSchedules/cancelClassSchedule`, data);

      const resp = response.data.success;
      return resp;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("postCancelClass", error);

      dispatch(setError(error.message));
      dispatch(endLoading());
      return error;
    }
  };
};

export const getLingoPlans = (criteriaObj) => {
  return async (dispatch) => {
    const criteria =
      criteriaObj !== null
        ? criteriaObj
        : {
            active: true,
            lingoLanguageId: null,
            planName: null,
            bestSeller: null,
            skip: null,
            take: null,
          };

    try {
      const response = await api.post(`/plans/search`, {
        criteria,
      });

      const resp = response.data.result.items;
      dispatch(setLingoPlans(resp));
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getLingoPlans", error);

      dispatch(setError(error.message));

      return error;
    }
  };
};

export const getSequentialClasses = (
  { pageNumber, pageSize, recurrentScheduleId, sequentialScheduleId },
  sequential = false,
) => {
  return async (dispatch) => {
    const paramSchedule = !sequential
      ? "&recurrentScheduleId=" + recurrentScheduleId
      : "&sequentialScheduleId=" + sequentialScheduleId;

    try {
      const response = await api.get(`/classSchedules?pageNumber=${pageNumber}&pageSize=${pageSize}${paramSchedule}`);
      const resp = response.data.result.items;
      return resp;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getLevel", error);

      dispatch(setError(error.message));
      return false;
    }
  };
};

export const getDetailsClass = (classId) => {
  return async () => {
    try {
      const response = await api.get(`classSchedules?id=${classId}`);
      return response.data.result.items[0];
    } catch (error) {
      console.log("getDetailsClass", error);
      return false;
    }
  };
};

export const getPreviousClasses = (body) => {
  return async (dispatch) => {
    try {
      const response = await api.post("/classSchedulesForm/classDetailsPreviousClasses", body);

      if (response.data.success) {
        dispatch(setAllPreviousClasses(Object.values(response.data.result.items[0])));
      } else {
        dispatch(setAllPreviousClasses([]));
      }
    } catch (error) {
      console.log("getPreviousClasses", error);
    }
  };
};

export const getNextClasses = (body) => {
  return async (dispatch) => {
    try {
      const response = await api.post("/classSchedulesForm/classDetailsNextClasses", body);

      if (response.data.success) {
        dispatch(setAllNextClasses(response.data.result.items));
      } else {
        dispatch(setAllNextClasses([]));
      }
    } catch (error) {
      console.log("getNextClasses", error);
    }
  };
};

export const getLastSchedules = (body) => {
  return async (dispatch) => {
    try {
      const response = await api.post("/classSchedulesForm/lastSchedules", body);

      if (response.data.success) {
        dispatch(setAllLastSchedules(response.data.result.items));
      } else {
        dispatch(setAllLastSchedules([]));
      }
    } catch (error) {
      console.log("getLastSchedules", error);
    }
  };
};

export const getTeachersAll = () => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get(`teachermanagement?skip=0&take=99999&active=true`);
      const resp = response.data.result.items;
      dispatch(setAllTeachers(resp));
    } catch (error) {
      console.log("getDetailsClass", error);
      dispatch(endLoading());
      return false;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getLingoRatingCriterias = (loading = false) => {
  return async (dispatch) => {
    loading && dispatch(initLoading());

    try {
      const response = await api.get(`/ratingcriterias?skip=0&take=100&active=true`);
      const resp = response.data.result.items;

      dispatch(setRatingCriterias(resp));
    } catch (error) {
      console.log("getLevel", error);
      dispatch(endLoading());
      dispatch(setError(error.message));
      return false;
    } finally {
      loading && dispatch(endLoading());
    }
  };
};

export const getClassesForRating =
  (user, loading = false) =>
  async (dispatch) => {
    loading && dispatch(initLoading());

    if (!user || (user?.role !== "teacher" && user?.role !== "student")) {
      return;
    }

    const target = () => {
      if (user?.role === "student") return "teacherRating";
      if (user?.role === "teacher") return "studentRating";
    };

    const language = localStorage.getItem("i18nextLng");
    const lang = `&lang=${language}`;

    try {
      const response = await api.get(`ClassScheduleRatingNew?pageNumber=1&pageSize=20&status=done${lang}`);
      const resp = response.data.result.items[0];

      const targetString = user?.role === "student" ? "teacherRating" : user?.role === "teacher" ? "studentRating" : "";
      let ratingTarget = resp.filter((item) => {
        return (
          item.status !== "canceled" &&
          item.status !== "canceledLingo" &&
          item.status !== "pending" &&
          item.status !== "noShow" &&
          !item[targetString] &&
          item.teacher !== null
        );
      });

      if (!ratingTarget) {
        return;
      }

      ratingTarget = ratingTarget[0];

      let classesForRating = ratingTarget
        ? resp.filter((item) => item.sequentialScheduleId === ratingTarget.sequentialScheduleId)
        : [];

      if (classesForRating.length > 0) {
        classesForRating[0][target()]?.length
          ? await api
              .get(`ratings/get${cap(target())}/${classesForRating[0][target()].id}`)
              .then((res) => {
                classesForRating[0].criteriasGrades = res.data.result.items[0][
                  `${user?.role === "student" ? "teacher" : "student"}CriteriaRatings`
                ].map((item) => {
                  return {
                    id: item.ratingCriteriaId,
                    value: item.grade,
                  };
                });
                dispatch(setClassesForRating(classesForRating));
              })
              .catch((res) => console.log(res))
          : dispatch(setClassesForRating(classesForRating));
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getLevel", error);

      dispatch(setError(error.message));
      return false;
    }
    loading && dispatch(endLoading());
  };

export const getClassesRating =
  (filter, loading = false) =>
  async (dispatch) => {
    const language = localStorage.getItem("i18nextLng");

    const lang = `&lang=${language}`;
    const startAt = filter.startAt !== "" ? `&startAt=${filter.startAt}` : "";
    const endAt = filter.endAt !== "" ? `&endAt=${filter.endAt}` : "";
    const studentId = filter.studentId !== "" ? `&studentId=${filter.studentId}` : "";
    const teacher = filter.teacher !== "" ? `&teacher=${filter.teacher}` : "";
    const student = filter.student !== "" ? `&student=${filter.student}` : "";
    const lingoLanguageId = filter.lingoLanguageId !== "" ? `&languageId=${filter.lingoLanguageId}` : "";
    const studentLevel = filter.levelId !== "" ? `&studentLevel=${filter.levelId}` : "";
    const classRatingStatus = filter.classRatingStatus !== "" ? `&classRatingStatus=${filter.classRatingStatus}` : "";

    try {
      loading && (await dispatch(initLoading()));

      const response = await api.get(
        `ClassScheduleRatingNew?pageNumber=${filter.pageNumber}&pageSize=${filter.pageSize}${startAt}${endAt}${studentId}${classRatingStatus}${studentLevel}${lingoLanguageId}${teacher}${student}${lang}`,
      );

      if (response.data.success) return response.data.result;
      else return [];
    } catch (error) {
      console.log("getClassesRating", error);
      dispatch(setError(error.message));
      return [];
    } finally {
      loading && (await dispatch(endLoading()));
    }
  };

export const getClassesRatingAVGByTeacher = (teacherId) => async (dispatch) => {
  try {
    const response = await api.get(`/ratings/getAverageByTeacher/${teacherId}`);

    if (response.data.success) {
      return response.data.result.items;
    } else {
      return [];
    }
  } catch (error) {
    console.log("getClassesRatingAVGByTeacher", error);
    dispatch(setError(error.message));
    return [];
  }
};

export const getClassesRatingById = (id) => async (dispatch) => {
  try {
    const response = await api.get(`/ratings/getTeacherRating/${id}`);
    const resp = response.data.result.items[0];
    return resp;
  } catch (error) {
    if (error.message === "Network Error") {
      if (window?.caches) {
        caches.keys().then((cacheNames) => {
          cacheNames.forEach((cacheName) => {
            caches.delete(cacheName);
          });
        });
      }
      dispatch(logout());
    }
    console.log("getClassesRatingById", error);

    dispatch(setError(error.message));
    dispatch(endLoading());
    return false;
  }
};

export const sendRatings =
  ({ user, ratingClassObj, target, action, updateScreen, blockTeacher }) =>
  async (dispatch) => {
    try {
      const callApi = async () => {
        if (action === "create") {
          return await api.post(`ratings/${action}${cap(target)}Rating`, ratingClassObj);
        } else {
          return await api.put(`ratings/${action}${cap(target)}Rating`, ratingClassObj);
        }
      };

      await dispatch(initLoading());

      await callApi()
        .then(async (res) => {
          if (res.data && res.data.success && blockTeacher) {
            await api.post(`studentManagement/createStudentTeacherRestriction`, blockTeacher);
          }
          updateScreen && updateScreen();
          dispatch(unsetClassesForRating(user));
        })
        .catch((err) => {
          console.log(err.response);
        });
    } catch (error) {
      console.log("getLevel", error);

      dispatch(setError(error.message));
      return false;
    } finally {
      await dispatch(endLoading());
    }
  };

export const unsetClassesForRating = () => (dispatch) => {
  dispatch(setClassesForRating([]));
};

export const getLangAll = (loading = false) => {
  return async (dispatch) => {
    loading && dispatch(initLoading());

    try {
      const response = await api.get(`/lingolanguages/getall`);
      dispatch(
        setAllLingos(
          response?.data?.result?.items.map((item) => ({
            ...item,
            language: { name: decryptIfEncrypted(item.language.name) },
          })),
        ),
      );
    } catch (error) {
      console.log("getLangAll", error);
    } finally {
      loading && dispatch(endLoading());
    }
  };
};

export const handleChangeLanguagePlan = (lingoLanguageId) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get(`/planprices/getByLingoLanguage/${lingoLanguageId}/false`);
      return response.data;
    } catch (error) {
      console.log("handleChangeLanguagePlan", error);
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const validateCoupon = (code, plan) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get(`coupons/validatecoupon?couponKey=${code}&planId=${plan}`);
      return response.data;
    } catch (error) {
      console.log("handleChangeLanguagePlan", error);
      dispatch(endLoading());
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getLingoTools = () => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get(`/tools`);
      dispatch(setLingoTools(response?.data?.result?.items));
    } catch (error) {
      console.log("getLingoTools", error);
      dispatch(endLoading());
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getSubscriptionStatus = (paypalStatus, paypalToken) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      await api.get(`/subscriptions/${paypalStatus}Subscription?token=${paypalToken}`);
    } catch (error) {
      console.log("getSubscriptionStatus", error);
      dispatch(endLoading());
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getTeacherWithNativeLanguage = (languageId) => {
  return async () => {
    try {
      const response = await api.get(`teachermanagement/getTeacherWithNativeLanguage/${languageId}`);
      return response?.data?.result?.items;
    } catch (error) {
      console.log("getTeacherWithNativeLanguage", error);
    }
  };
};

export const getLevels = () => {
  return async (dispatch) => {
    try {
      const response = await api.get(`levels`);
      dispatch(setLevels(response?.data?.result?.items));
    } catch (error) {
      console.log("getLevels", error);
    }
  };
};

export const getCountries = () => {
  return async () => {
    try {
      const response = await api.get(`countries/getall`);
      return response?.data?.result?.items.map((item) => ({ ...item, name: decryptIfEncrypted(item.name) }));
    } catch (error) {
      console.log("getCountries", error);
    }
  };
};

export const getCountriesPrices = () => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get(`pricecountries/list?skip=0&take=255`);
      return response?.data?.result?.items.map((item) => ({
        ...item,
        country: { name: decryptIfEncrypted(item.country.name) },
        lingoLanguage: { ...item.lingoLanguage, language: decryptIfEncrypted(item.lingoLanguage.language.name) },
      }));
    } catch (error) {
      console.log("getCountriesPrices", error);
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getPlansAndPrices = (id) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get(`planprices${id === "new" ? "" : "/" + id}`);
      return response?.data?.result?.items;
    } catch (error) {
      console.log("getCountriesPrices", error);
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const deletePrices = (id) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      await api.delete(`prices/${id}`);
    } catch (error) {
      console.log("deletePrices", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
    } finally {
      dispatch(endLoading());
    }
  };
};

export const deletePlanPrices = (id) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      await api.delete(`planprices/${id}`);
    } catch (error) {
      console.log("deletePlanPrices", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postPlanPrices = (data) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post(`planprices/`, data);
      return response.data;
    } catch (error) {
      console.log("postPlanPrices", error);
      dispatch(setError(error.message));
      dispatch(endLoading());

      throw error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getGlobalLanguages = () => {
  return async () => {
    try {
      const response = await api.get(`languages?skip=0&take=999999`);
      return response?.data?.result?.items.map((item) => ({ ...item, name: decryptIfEncrypted(item.name) }));
    } catch (error) {
      console.log("getGlobalLanguages", error);
    }
  };
};

export const getEconomicGroups = () => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get(`economicgroups?skip=0&take=9999`);
      return response?.data?.result?.items.map((item) => ({ ...item, name: decryptIfEncrypted(item.name) }));
    } catch (error) {
      console.log("getEconomicGroups", error);
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getCompanies = () => {
  return async (dispatch) => {
    dispatch(initLoading());

    const filterCompanies = {
      pageNumber: 1,
      pageSize: 999,
      socialName: null,
      fantasyName: null,
      documentNumber: null,
      economicGroupId: null,
      registerDate: "1910-01-01",
      active: true,
      responsibleName: null,
      responsibleEmail: null,
    };

    try {
      const response = await api.post(`companies/search`, filterCompanies);
      return response?.data?.result?.items;
    } catch (error) {
      console.log("getCompanies", error);
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getNotif = (id, page = 1, qtd = 10) => {
  return async (dispatch) => {
    try {
      const responselength = await api.get(
        `/notificationmanager/getByNotificationSentToUserId?id=${id}&pageNumber=${page}&pageSize=${qtd}`,
      );

      const resp = responselength?.data?.result?.items;
      dispatch(setNotif(resp));

      dispatch(
        setPaginationNotif({
          pageNumber: responselength?.data?.result.pageNumber,
          pageSize: qtd,
          totalPages: responselength?.data?.result.totalPages,
          totalFound: responselength?.data?.result.totalFound,
        }),
      );

      return resp;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getNotif", error.response);
      dispatch(setError(error.message));
    }
  };
};

export const getNotifLength = (id, loading = false) => {
  return async (dispatch) => {
    loading && dispatch(initLoading());

    try {
      const responselength = await api.get(`/notificationmanager/getUnreadNotifications?id=${id}`);

      const resp = responselength?.data?.result?.items;

      dispatch(setLengthNotif(resp[0]));

      return resp;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getNotif", error.response);
      loading && dispatch(endLoading());
      dispatch(setError(error.message));
    } finally {
      loading && dispatch(endLoading());
    }
  };
};

export const readNotif = (body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      await api.put(`/notificationmanager/updateSentToUser`, body);
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("readNotif", error.message);
      dispatch(endLoading());
      return false;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const readNotifAll = (body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      await api.put(`/notificationmanager/updateAllSentToUser`, body);
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("readNotif", error.message);
      dispatch(endLoading());
      return false;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const updateMultipleStudentPlanLanguage = (body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      await api.put(`accountManagement/updateMultipleStudentPlanLanguage`, body);
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("updateMultipleStudentPlanLanguage", error.message);
      dispatch(endLoading());
      return false;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const updateNotificationsSettings = (body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const res = await api.put(`notificationsettings`, body);
      return res.data;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("updateNotificationsSettings", error.message);
      dispatch(endLoading());
      return false;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postNotificationsSettings = (body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const res = await api.post(`notificationsettings`, body);
      return res.data;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("postNotificationsSettings", error.message);
      dispatch(endLoading());
      return false;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const updateLingoNotification = (body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      await api.put(`/notificationmanager`, body);
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("readNotif", error.message);
      dispatch(endLoading());
      return false;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getNotificationSettingsUser = (userId) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get(`notificationsettings/getbyuser/${userId}`);
      return response?.data?.result?.items[0];
    } catch (error) {
      dispatch(endLoading());
      dispatch(setError(error.message));
      return false;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getCalendarAuthUrl = (provider, state) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get(`/calendar/oauth/${provider}/auth-url?state=${state}`);
      return response.data.result.items[0].url;
    } catch (error) {
      console.log("getCalendarAuthUrl", error.message);
      dispatch(setError(error.message));
      return false;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const exchangeGoogleCalendarCode = (payload) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const res = await api.post(`/calendar/oauth/google/exchange-code`, payload);
      return res?.data;
    } catch (error) {
      console.log("exchangeGoogleCalendarCode", error.message);
      dispatch(setError(error.message));
      return false;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getStatusCollab = () => {
  return async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_LINK_API_COLLAB + "/health/live");
      return response.data;
    } catch (error) {
      console.log("getStatusCollab", error.message);
      return false;
    }
  };
};

export const getAllPlans = () => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get(`/plans?skip=0&take=100`);

      const resp = response.data.result.items;
      dispatch(setAllPlans(resp));
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getLingoPlans", error);
      dispatch(endLoading());

      dispatch(setError(error.message));
      return error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getDemoClasses = (filters) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get(
        `/demoClasses?pageNumber=${filters.pageNumber}&pageSize=${filters.pageSize}&startAt=${filters.startAt}&endAt=${filters.endAt}&email=${filters.email}&lingoLanguageId=${filters.lingoLanguageId}&status=${filters.status}&student=${filters.student}&orderByDesc=${filters.orderByDesc}`,
      );
      await dispatch(
        setDemoClasses({
          demoClasses: response.data.result.items,
          totalPages: response.data.result.totalPages,
          totalFound: response.data.result.totalFound,
        }),
      );
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getDemoClasses", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getDemoClassById = (id) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get(`/demoClasses/${id}`);
      const resp = response?.data?.result?.items;

      await dispatch(setDemoClass(resp));
      return resp[0];
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getDemoClassById", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getDemoClassMessages = (demoClassId) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get(`/demoClasses/${demoClassId}/demoClassHistories`);
      const resp = response?.data?.result?.items;
      dispatch(setDemoClassMessages(resp));
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getDemoClassMessages", error);
      dispatch(endLoading());
      dispatch(setError(error.message));
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getCoordinators = () => {
  return async (dispatch) => {
    dispatch(initLoading());

    let newFilter = {
      take: null,
      skip: null,
      name: null,
      countryId: 26,
      status: null,
      nativeLanguageId: null,
      otherLanguageId: null,
      responsibleLanguageId: null,
    };

    try {
      const response = await api.get(`coordinators/search`, newFilter);
      const resp = response?.data?.result?.items;
      return resp;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getCoordinators", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const editDemoClass = (submitObj) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.put(`demoClasses/${submitObj.id}`, JSON.parse(JSON.stringify(submitObj)));
      return response?.data;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("editDemoClass", error);
      dispatch(endLoading());
      throw error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postDemoClass = (submitObj) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post(`/demoClasses`, JSON.parse(JSON.stringify(submitObj)));
      return response?.data;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("postDemoClass", error.message);
      dispatch(endLoading());

      throw error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const validateVersion = (userId, version) => {
  return async () => {
    try {
      const response = await api.get(`/validateAppVersion?device=web&appversion=${version}&userId=${userId}`);
      return response.data.result.items[0];
    } catch (error) {
      console.log("validateVersion", error);
    }
  };
};

export const clearNotify = (userId) => {
  return async (dispatch) => {
    try {
      const response = await api.post("/clear-notify", { userId });
      return response.data.success;
    } catch (error) {
      console.log("clearNotify", error);
    } finally {
      dispatch(endLoading());
    }
  };
};

export const recaptchaValidate = (token) => {
  return async (dispatch) => {
    try {
      const response = await api.post("/recaptcha/validate", { "g-recaptcha-response": token });
      console.log("recaptchaValidate", response.data);
      return response.data.success;
    } catch (error) {
      console.log("clearNotify", error);
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postAutoReview = () => {
  return async (dispatch) => {
    try {
      dispatch(initLoading());

      const response = await api.post("/classSchedulesForm/autoReview");
      return response.data.result.items;
    } catch (error) {
      console.log("postAutoReview", error);
    } finally {
      dispatch(endLoading());
    }
  };
};
